import { FormInputProps } from '@/@types/form.types';
import { cn } from '@/lib/utils';
import { Controller } from 'react-hook-form';
import InformationCircle from '@/components/icons/InformationCircle';
import { useTranslation } from 'react-i18next';
import { Switch } from '../ui/switch';

type Props<T extends {}> = {
    label?: string;
    text?: string;
    placeholder?: string;
    optional?: boolean;
    type?: React.InputHTMLAttributes<HTMLInputElement>['type'];
} & FormInputProps<T>;

const EToogler = <T extends {}>({
    label,
    text,
    optional = false,
    fieldName,
    control,
    className,
    containerClassName,
    disabled,
}: Props<T>) => {
    const { t } = useTranslation();

    return (
        <div className={cn('w-full flex flex-col gap-1.5 select-none', containerClassName)}>
            {label && (
                <h4 className="text-sm font-medium">
                    {label}
                    {optional && <span className="text-popover-600"> (optional)</span>}
                </h4>
            )}
            <Controller
                name={fieldName}
                control={control}
                render={({ field: { value, onChange, onBlur }, fieldState, formState }) => (
                    <>
                        <div className="h-11 flex items-center gap-4">
                            {text && <span className='text-sm'>{ text }</span>}
                            <Switch
                                className={cn('', className)}
                                checked={value ?? false}
                                onCheckedChange={(e) => onChange(e)}
                                onBlur={onBlur}
                                disabled={disabled || formState.disabled}
                            />
                        </div>
                        {fieldState.invalid && (
                            <div className="flex items-center gap-1.5">
                                <InformationCircle className="size-4 stroke-error-1000" />
                                <span className="text-xs text-error-1000">
                                    {t(fieldState.error?.message as string)}
                                </span>
                            </div>
                        )}
                    </>
                )}
            />
        </div>
    );
};

export default EToogler;
